<template>
  <modal :show="showModal" @close="close">
    <div class="modal-header p-0 p-b-10 m-b-30">
      <h5>User Form</h5>
    </div>
    <div class="custom-modal-body-inner">
      <validation-observer v-slot="{ handleSubmit }" ref="form">
        <form @submit.prevent="handleSubmit(submit)">
          <div class="required-info">
              <div class="d-none">
                  <input type="password">
              </div>
            <div class="row">
                <div class="col-lg-6">
                    <validation-provider
                        vid="first_name"
                        name="First Name"
                        rules="required|max:100"
                        v-slot="{ errors }"
                        tag="div"
                        class="form-group"
                    >
                        <label for="first_name">
                            First Name:
                            <span class="required">*</span>
                        </label>
                        <div class="input-wrapper">
                            <input
                                type="text"
                                id="first_name"
                                v-model="model.first_name"
                                placeholder="First Name"
                                :class="{'is-invalid':errors.length}"
                                class="form-control"
                                autocomplete="off"
                            />
                            <div class="invalid-feedback">{{ errors[0] }}</div>
                        </div>
                    </validation-provider>
                </div>

                <div class="col-lg-6">
                    <validation-provider
                        vid="last_name"
                        name="Last Name"
                        rules="max:100"
                        v-slot="{ errors }"
                        tag="div"
                        class="form-group"
                    >
                        <label for="last_name">
                            Last Name:
                        </label>
                        <div class="input-wrapper">
                            <input
                                type="text"
                                id="last_name"
                                v-model="model.last_name"
                                placeholder="Last Name"
                                :class="{'is-invalid':errors.length}"
                                class="form-control"
                                autocomplete="off"
                            />
                            <div class="invalid-feedback">{{ errors[0] }}</div>
                        </div>
                    </validation-provider>
                </div>

<!--                <div class="col-lg-6">-->
<!--                <validation-provider-->
<!--                  name="name"-->
<!--                  rules="required|max:100"-->
<!--                  v-slot="{ errors }"-->
<!--                  tag="div"-->
<!--                  class="form-group"-->
<!--                >-->
<!--                  <label for="name">-->
<!--                    Name:-->
<!--                    <span class="required">*</span>-->
<!--                  </label>-->
<!--                  <div class="input-wrapper">-->
<!--                    <input-->
<!--                      type="text"-->
<!--                      id="name"-->
<!--                      v-model="model.name"-->
<!--                      placeholder="Name"-->
<!--                      :class="{'is-invalid':errors.length}"-->
<!--                      class="form-control"-->
<!--                      autocomplete="off"-->
<!--                    />-->
<!--                    <div class="invalid-feedback">{{ errors[0] }}</div>-->
<!--                  </div>-->
<!--                </validation-provider>-->
<!--              </div>-->
              <!-- End .col -->
              <div class="col-lg-6">
                <validation-provider
                  name="email"
                  rules="required|max:100|email"
                  v-slot="{ errors }"
                  tag="div"
                  class="form-group"
                >
                  <label for="email-field">
                    Email:
                    <span class="required">*</span>
                  </label>
                  <div class="input-wrapper">
                    <input
                      type="text"
                      id="email-field"
                      v-model="model.email"
                      placeholder="Email"
                      :class="{'is-invalid':errors.length}"
                      class="form-control"
                      autocomplete="off"
                    />
                    <div class="invalid-feedback">{{ errors[0] }}</div>
                  </div>
                </validation-provider>
              </div>
              <!-- End .col -->
              <div class="col-lg-6">
                <validation-provider
                  name="role"
                  rules="required|max:3"
                  v-slot="{ errors }"
                  tag="div"
                  class="form-group"
                >
                  <label for="roles">Roles:</label>
                  <div class="select-wrapper">
                    <select
                    id="roles"
                    v-model="model.role"
                    class="custom-select form-control"
                    placeholder="Select One"
                    :class="{'is-invalid':errors.length}"
                  >
                    <option value>Select one</option>
                    <option v-for="(item, index) in roles" :value="index">{{ item | capitalize }}</option>
                  </select></div>

                  <div class="invalid-feedback">{{ errors[0] }}</div>
                </validation-provider>
              </div>

              <div class="col-md-6">
                <validation-provider
                  name="password"
                  vid="password"
                  :rules="{ required,min:5,max:100 }"
                  v-slot="{ errors }"
                  tag="div"
                  class="form-group"
                >
                  <label for="password">New Password:</label>
                  <div class="input-wrapper">
                    <input
                      name="password"
                      id="password"
                      :type="password_field_type1"
                      v-model="model.password"
                      placeholder="New Password"
                      class="form-control"
                      :class="{'is-invalid':errors.length}"
                      autocomplete="off"
                    />
                    <i
                      class="far"
                      :class="{'fa-eye-slash':password_field_type1=='password', 'fa-eye':password_field_type1=='text'}"
                      @click="togglePasswordEye1"
                    ></i>
                    <div class="invalid-feedback">{{ errors[0] }}</div>
                  </div>
                </validation-provider>
              </div>
              <!-- End col -->
              <div class="col-md-6">
                <validation-provider
                  name="password_confirmation"
                  rules="password_confirmation:@password"
                  v-slot="{ errors }"
                  tag="div"
                  class="form-group"
                >
                  <label for="password_confirmation">Confirm New Password:</label>
                  <div class="input-wrapper">
                    <input
                      :type="password_field_type2"
                      class="form-control"
                      id="password_confirmation"
                      v-model="model.password_confirmation"
                      placeholder="Confirm New Password"
                      :class="{'is-invalid':errors.length}"
                      autocomplete="off"
                    />
                    <i
                      class="far"
                      :class="{'fa-eye-slash':password_field_type2=='password', 'fa-eye':password_field_type2=='text'}"
                      @click="togglePasswordEye2"
                    ></i>
                    <div class="invalid-feedback">{{ errors[0] }}</div>
                  </div>
                </validation-provider>
              </div>
            </div>
            <button type="submit" class="primary-btn mx-auto">{{ submit_btn_name }}</button>
          </div>
            <div class="d-none">
                <input name="email" type="email"/>
            </div>
        </form>
      </validation-observer>
    </div>
  </modal>
</template>
<script>
const Swal = require("sweetalert2");
export default {
  data() {
    return {
      showModal: false,
      get_url: "/dashboard/users/edit/",
      post_url: "",
      roles: {},
      model: {},
      submit_btn_name: "",
      required: false,
      is_submitted: false,
      password_field_type1: "password",
      password_field_type2: "password"
    };
  },
  created() {},
  methods: {
    openModal: function(id) {
      if (id) {
        this.post_url = "/dashboard/users/edit/" + id;
        this.submit_btn_name = "Update Changes";
      } else {
        this.post_url = "/dashboard/users/create";
        this.required = true;
        this.submit_btn_name = "Submit";
      }
      var _this = this;
      axios
        .get(this.get_url + id)
        .then(({ data }) => {
          this.showModal = true;
          this.roles = data.roles;
          this.model = data.model;

          if (!this.model.role) {
            this.model.role = "";
          }
        })
        .catch(function(error) {
          _this.$throwSwalError(error);
        });
    },
    close: function() {
      this.showModal = false;
      this.required = false;
      this.model = {};
      this.$nextTick(() => this.$refs.form.reset());
    },
    submit: function(e) {
      this.is_submitted = true;
      axios
        .post(this.post_url, this.model)
        .then(response => {
          this.close();
            this.$parent.extra_params.load_counter = true;
            this.$parent.fetchData();
          this.is_submitted = false;
          Swal.fire({
            position: "center",
            icon: "success",
              title: "Action completed!",
            showConfirmButton: false,
            timer: 1500
          });
        })
        .catch(error => {
          this.is_submitted = false;
          if (error.response.status == 422) {
            this.error_message = error.response.data.message;
            this.$refs.form.setErrors(error.response.data.errors);
          } else {
            this.showModal = false;
            this.$throwSwalError(error);
            this.error_message = "Something wrong at form!";
          }
        });
    },
    togglePasswordEye1: function(e) {
      if (this.password_field_type1 == "password") {
        this.password_field_type1 = "text";
      } else {
        this.password_field_type1 = "password";
      }
    },
    togglePasswordEye2: function(e) {
      if (this.password_field_type2 == "password") {
        this.password_field_type2 = "text";
      } else {
        this.password_field_type2 = "password";
      }
    }
  },
  components: {
    modal: require("./../Modal").default
  }
};
</script>
